import React, { Fragment } from 'react'
import ReactHtmlParser from 'html-react-parser'
import Range from 'react-input-range'
import $ from 'jquery'
import CircularScale from '../../../../components/CircularScale/'
import 'react-input-range/lib/css/index.css'

class Slider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.isMobile ? 0 : props.slider.value,
      isInit: false
    }
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    const { rawAnswers, storeAnswer, index } = this.props
    if (rawAnswers) {
      this.setState(rawAnswers, () => this.setState({ isInit: true }))
    } else {
      storeAnswer(index, this.state)
      this.setState({ isInit: true })
    }
    if (this.props.isMobile) {
      setTimeout(() => {
        $('.NPSScale-Values').animate({ scrollLeft: 40 }, 400)
      }, 500)
    }
  }

  handleChange(value) {
    const { storeAnswer, checkSurveyState, index } = this.props
    this.setState({ value }, () => {
      storeAnswer(index, this.state)
      checkSurveyState(this)
    })
  }

  render() {
    const { slider, question, label, className } = this.props

    return (
      <div className={`${className}`}>
        <div className="surveys-intro row collapse">
          <div className="small-12 columns">
            <h3>{ReactHtmlParser(question)}</h3>
          </div>
        </div>

        {!this.props.isMobile || !this.state.isInit ? (
          <Fragment>
            <br />
            <br />
            <div className="row surveys-container survey-slider-container collapse">
              <Range
                maxValue={slider.max}
                minValue={slider.min}
                value={this.state.value}
                // formatLabel={label ? value => `${value} ${label}` : null}
                onChange={this.handleChange}
              />
            </div>

            <div className={`survey-slider-label`}>
              <span>{label.min}</span>
              <span>{label.max}</span>
            </div>
            <br />

            <br />
          </Fragment>
        ) : (
          <div className="feedback-ratings-container">
            <CircularScale
              selectedValue={this.state.value}
              onSubmit={({ score }) => this.handleChange(score)}
            />
            <br />
            <br />
            <br />
            <br />
          </div>
        )}
      </div>
    )
  }
}

export default Slider
